import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Container, Paper } from "@mui/material";
import BaseOrgChartView from "../Views/BaseOrgChartView";
import { fetchOrgChartTypes } from "../../Domain/Services/GetOrgChartService";

const HIDDEN_COMPANY_CHART_TYPES = ["VACACIONES", "EXTRAS"];

const PublicOrgChartView = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const structureQuery = searchParams.get("structure") || searchParams.get("chartType");
  const [availableChartTypes, setAvailableChartTypes] = useState([]);
  const [selectedChartType, setSelectedChartType] = useState(structureQuery || "GENERAL");

  useEffect(() => {
    fetchOrgChartTypes()
      .then(types => {
        const filteredTypes = (types || []).filter(
          (type) => !HIDDEN_COMPANY_CHART_TYPES.includes((type || "").toUpperCase())
        );
        setAvailableChartTypes(filteredTypes);

        if (structureQuery) {
          const matched = filteredTypes.find(
            (t) => (t || "").toUpperCase() === structureQuery.toUpperCase()
          );
          if (matched) {
            setSelectedChartType(matched);
            return;
          }
        }

        const generalMatch = filteredTypes.find(
          (type) => (type || "").toUpperCase() === "GENERAL"
        );
        if (generalMatch) {
          setSelectedChartType(generalMatch);
        } else if (filteredTypes.length > 0) {
          setSelectedChartType(prev => (filteredTypes.includes(prev) ? prev : filteredTypes[0]));
        }
      })
      .catch(console.error);
  }, [structureQuery]);

  const handleChartTypeChange = (newType) => {
    setSelectedChartType(newType);
    if (newType && newType.toUpperCase() !== "GENERAL") {
      setSearchParams({ structure: newType });
    } else {
      setSearchParams({});
    }
  };

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4, px: { xs: 2, md: 4 } }}>
      <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3, bgcolor: '#f8fafd', minHeight: '85vh' }}>
        <BaseOrgChartView
          chartType={selectedChartType}
          title={t('orgChart.title.publicOrgChart')}
          description="Explora las estructuras jerárquicas de la organización de forma interactiva."
          showFilters={true}
          availableChartTypes={availableChartTypes}
          onChartTypeChange={handleChartTypeChange}
          displayMode="default"
        />
      </Paper>
    </Container>
  );
};

export default PublicOrgChartView;
